import {command, query, queryOne, querySearch} from "../utils/api";

const GET_SELL_LIMITS_URL = `${process.env.PUBLIC_URL}/api/v1/r/sellLimits`;
export const GET_SELL_LIMITS = 'GET_SELL_LIMITS';
export const GET_SELL_LIMITS_COMPLETED = 'GET_SELL_LIMITS_COMPLETED';
export const GET_SELL_LIMITS_FAILED = 'GET_SELL_LIMITS_FAILED';

export function getSellLimits(payload) {
  const pagination = payload && payload.pagination;
  return query(GET_SELL_LIMITS_URL, {}, GET_SELL_LIMITS, GET_SELL_LIMITS_COMPLETED, GET_SELL_LIMITS_FAILED,
    pagination);
}

export const SEARCH_SELL_LIMITS = 'SEARCH_SELL_LIMITS';
export const SEARCH_SELL_LIMITS_COMPLETED = 'SEARCH_SELL_LIMITS_COMPLETED';
export const SEARCH_SELL_LIMITS_FAILED = 'SEARCH_SELL_LIMITS_FAILED';
export const searchSellLimits = querySearch(GET_SELL_LIMITS_URL, SEARCH_SELL_LIMITS, SEARCH_SELL_LIMITS_COMPLETED,
  SEARCH_SELL_LIMITS_FAILED, ['name']);

export const GET_SELL_LIMIT = 'GET_SELL_LIMIT';
export const GET_SELL_LIMIT_COMPLETED = 'GET_SELL_LIMIT_COMPLETED';
export const GET_SELL_LIMIT_FAILED = 'GET_SELL_LIMIT_FAILED';

export function getSellLimit({sellLimitId}) {
  return queryOne(GET_SELL_LIMITS_URL, {where: {sellLimitId}}, GET_SELL_LIMIT, GET_SELL_LIMIT_COMPLETED, GET_SELL_LIMIT_FAILED);
}

const ADD_SELL_LIMIT_URL = `${process.env.PUBLIC_URL}/api/v1/sellLimit/add`;
export const ADD_SELL_LIMIT = 'SET_SELL_LIMIT';
export const ADD_SELL_LIMIT_COMPLETED = 'SET_SELL_LIMIT_COMPLETED';
export const ADD_SELL_LIMIT_FAILED = 'SET_SELL_LIMIT_FAILED';

export const addSellLimit = command(ADD_SELL_LIMIT_URL, ADD_SELL_LIMIT, ADD_SELL_LIMIT_COMPLETED,
  ADD_SELL_LIMIT_FAILED);

const UPDATE_SELL_LIMIT_URL = `${process.env.PUBLIC_URL}/api/v1/sellLimit/update`;
export const UPDATE_SELL_LIMIT = 'ADD_SELL_LIMIT';
export const UPDATE_SELL_LIMIT_COMPLETED = 'ADD_SELL_LIMIT_COMPLETED';
export const UPDATE_SELL_LIMIT_FAILED = 'ADD_SELL_LIMIT_FAILED';

export const updateSellLimit = command(UPDATE_SELL_LIMIT_URL, UPDATE_SELL_LIMIT, UPDATE_SELL_LIMIT_COMPLETED,
  UPDATE_SELL_LIMIT_FAILED);

const DELETE_SELL_LIMIT_URL = `${process.env.PUBLIC_URL}/api/v1/sellLimit/delete`;
export const DELETE_SELL_LIMIT = 'DELETE_SELL_LIMIT';
export const DELETE_SELL_LIMIT_COMPLETED = 'DELETE_SELL_LIMIT_COMPLETED';
export const DELETE_SELL_LIMIT_FAILED = 'DELETE_SELL_LIMIT_FAILED';

export const deleteSellLimit = command(DELETE_SELL_LIMIT_URL, DELETE_SELL_LIMIT, DELETE_SELL_LIMIT_COMPLETED,
  DELETE_SELL_LIMIT_FAILED);



// WEBPACK FOOTER //
// ./src/SellLimit/actions.js